import Api from "~/service/Api";

class CreditPurchaseRepository {
  create(data) {
    return Api.post(`/credit/purchases`, data);
  }
}

export default CreditPurchaseRepository;
